import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SidenavService } from './sidenav/sidenav.service';
import { filter, map, startWith } from 'rxjs/operators';
import { ThemeService } from '../../@prep/services/theme.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '../../@prep/utils/check-router-childs-data';
import { hiddenRoutes } from './data/vt-route-list';

@Component({
  selector: 'prep-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {

  sidenavOpen$ = this.sidenavService.open$;
  sidenavMode$ = this.sidenavService.mode$;
  sidenavCollapsed$ = this.sidenavService.collapsed$;
  sidenavExpanded$ = this.sidenavService.expanded$;
  quickPanelOpen: boolean;

  sideNavigation$ = this.themeService.config$.pipe(
    map((config) => config.navigation === 'side')
  );
  topNavigation$ = this.themeService.config$.pipe(
    map((config) => config.navigation === 'top')
  );
  toolbarVisible$ = this.themeService.config$.pipe(
    map((config) => config.toolbarVisible)
  );
  toolbarPosition$ = this.themeService.config$.pipe(
    map((config) => config.toolbarPosition)
  );
  footerPosition$ = this.themeService.config$.pipe(
    map((config) => config.footerPosition)
  );

  scrollDisabled$ = this.router.events.pipe(
    filter<NavigationEnd>((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() =>
      checkRouterChildsData(
        this.router.routerState.root.snapshot,
        (data) => data.scrollDisabled
      )
    )
  );
  hideSidebarNavigation = true;
  constructor(
    private sidenavService: SidenavService,
    private themeService: ThemeService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hideSidebarNavigation = hiddenRoutes.some(route =>
          event.urlAfterRedirects.includes(route)
        );
      }
    });

   }

  ngOnInit() {
    this.themeService.setToolbarVisible(true);
    this.themeService.setFooterVisible(true);
    // Side nav Collapse on Layout level
    this.sidenavService.setCollapsed(true);
  }

  skipToContent(event: Event) {
    event.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      main.setAttribute('tabindex', '-1'); // ensure it can be focused
      main.focus();
    }
  }

  openQuickPanel() {
    this.quickPanelOpen = true;
  }

  closeSidenav() {
    this.sidenavService.close();
  }

  openSidenav() {
    this.sidenavService.open();
  }

  ngOnDestroy(): void { }
}
